import React, { useState, useEffect } from 'react';
import {
  InputNumber,
  Button,
  Form, Select, Divider,
  Space,
  Modal
} from 'antd';
import {
  CloseOutlined,
  SaveOutlined
} from '@ant-design/icons';
import { getOrderPackageGoodsBySupplierId } from '../../services/Order'
import { sum } from '../../utils/Numeric';
import './style';

export default React.forwardRef((props, ref) => {
  const { filteredPallets, carton, progress, onCloseCallback, onSaveCallback } = props;
  const [form] = Form.useForm();
  const [goods, setGoods] = useState([]);
  const [goodsId, setGoodsId] = useState(undefined);
  const [palletId, setPalletId] = useState(undefined);
  const [count, setCount] = useState(undefined);
  const [goodsSpecId, setGoodsSpecId] = useState(undefined);
  const [goodsSpecId2, setGoodsSpecId2] = useState(undefined);
  const [weight, setWeight] = useState(undefined);
  const [cartonCount, setCartonCount] = useState(undefined);
  const [countPerCarton, setCountPerCarton] = useState(undefined);
  const onChangeCount = (value) => {
    setCount(value);
  }

  useEffect(() => {
    if (!goodsSpecId) return;
    const find = goods.find(x => x.goods_spec_id === goodsSpecId);
    if (find) {
      setCountPerCarton(find.pcs_per_carton);
      if (count) {
        if (count != undefined) {
          setCartonCount(Math.ceil(count / find.pcs_per_carton));
          setWeight((count * find.weight / 1000).toFixed(2))
        }
        if (find.pcs_per_carton) {
          let temp = parseInt(Math.floor(count / find.pcs_per_carton) * find.pcs_per_carton);
          if (temp < find.pcs_per_carton) temp = find.pcs_per_carton;
          setCount(temp);
        }
      }
    }
  }, [goodsSpecId, count]);

  const goodsOption = () => {
    const temp = [];
    goods.map((item, index) => {
      const exist = temp.find(x => x.id === item.goods_id);
      if (!exist) {
        temp.push({
          id: item.goods_id,
          name: item.goods_name,
        })
      }
    });
    return temp;
  }
  const goodsSpecOption = () => {
    const temp = [];
    goods.filter(g => g.goods_id === goodsId).map((item, index) => {
      const exist = temp.find(x => x.id === item.goods_spec_id);
      if (!exist) {
        temp.push({
          id: item.goods_spec_id,
          name: item.goods_spec_name,
          price: item.price,
          size: item.size
        })
      }
    });
    return temp;
  }

  useEffect(() => {
    getOrderPackageGoodsBySupplierId(carton.order_id, carton.supplier_id)
      .then(data => setGoods(data));
    setPalletId(carton.currentPalletId);
  }, []);

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSave = async () => {
    try {
      if (goodsSpecId != goodsSpecId2) {
        Modal.error({
          title: '产品确认',
          content: '产品尺寸和产品号不一致，请确认！',
        });
        return;
      }

      if (count === 0) {
        Modal.error({
          title: '产品数量确认',
          content: '产品数量必须大于0！',
        });
        return;
      }

      const values = await form.validateFields();
      values.package_id = carton.package_id;
      if (onSaveCallback) {
        onSaveCallback(Object.assign(carton, values), onClose);
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const initValue = [
    { name: ['supplier_id'], value: carton.supplier_id },
    { name: ['pallet_id'], value: palletId },
    { name: ['goods_id'], value: goodsId },
    { name: ['goods_spec_id'], value: goodsSpecId },
    { name: ['count'], value: count },
    { name: ['carton_count'], value: cartonCount },
    { name: ['count_per_carton'], value: countPerCarton },
    { name: ['weight'], value: weight },
  ];

  let left = 0;
  const find = progress.find(x => x.goods_spec_id === goodsSpecId);
  if (find) {
    const purchase = JSON.parse(find.supplier_purchase_detail_count || '[]').filter(x => x).filter(x => x[0] === carton.supplier_id).map(y => y[1]);
    const ok = JSON.parse(find.supplier_ok_detail_count || '[]').filter(x => x).filter(x => x[0] === carton.supplier_id).map(y => y[1]);
    left = sum(purchase) - sum(ok);
  }
  return (
    <Form style={{ padding: '0 1rem' }} form={form} preserve={false} onFinish={onSave} fields={initValue} >
      <Form.Item label="托盘序号" name="pallet_id" rules={[{ required: true, message: '请选择托盘/散箱!' }]}>
        <Select
          disabled={true}
          onChange={setPalletId}
          showSearch="true"
          placeholder="请选择托盘/散箱"
          style={{ width: '100%' }}
        >
          {
            filteredPallets.filter(x => x.ds === 1).map((item, i) => (
              <Select.Option key={item.id} value={item.id}>
                第{i + 1}托盘
              </Select.Option>
            ))}
          <Select.Option key={-1} value={-1}>
            散箱
          </Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="产品名称" name="goods_id" rules={[{ required: true, message: '请选择产品名称!' }]} >
        <Select
          onChange={setGoodsId}
          showSearch="true"
          placeholder="请选择产品名称"
          style={{ width: '100%' }}
        >
          {
            goodsOption().map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item label="产品尺寸" name="size" rules={[{ required: true, message: '请选择产品尺寸!' }]}>
        <Select
          showSearch="true"
          placeholder="请选择产品尺寸"
          style={{ width: '100%' }}
          onChange={setGoodsSpecId2}
        >
          {
            goodsSpecOption().map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.size}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item label="　产品号" name="goods_spec_id" rules={[{ required: true, message: '请选择产品号!' }]}>
        <Select
          showSearch="true"
          placeholder="请选择产品号"
          style={{ width: '100%' }}
          onChange={setGoodsSpecId}
        >
          {
            goodsSpecOption().map(item => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
        <Form.Item label="件　　数" name="count" rules={[{ required: true, message: '请填写箱数整数倍，不足整箱时自动计算!' }]}>
          <InputNumber
            value={count && count > 0 ? count : undefined}
            placeholder="请填写箱数整数倍"
            onBlur={(e) => onChangeCount(e.target.value)} min={0} max={999999}
            style={{ width: '100%' }} />
        </Form.Item>
        <div>剩余<strong> {left} </strong>件</div>
      </div>
      <Form.Item label="箱　　数" name="carton_count" rules={[{ required: true, message: '请填写箱数!' }]}>
        <InputNumber disabled style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label="件数／箱" name="count_per_carton" rules={[{ required: true, message: '请填写每箱多少件!' }]}>
        <InputNumber disabled style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item label="重 量(KG)" name="weight" rules={[{ required: true, message: '请填写重量!' }]}>
        <InputNumber disabled style={{ width: '100%' }} />
      </Form.Item>
      <Divider />
      <div className="page-footer">
        <div></div>
        <Space size="large">
          <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
          <Button htmlType="submit" type="primary" icon={<SaveOutlined />}>保 存</Button>
        </Space>
      </div>
    </Form>)
});
